var $ = jQuery

export default function Print () {
  $(document).on('click', '.print', function (e) {
    window.print()

    e.preventDefault()
  })
}
